import React, { useContext } from 'react';
import t from 'react-translate';
import { useSelector } from 'react-redux';
import { css } from '@emotion/react';

// redux
import { getAiRolePlay } from 'redux/selectors/timeline';

import NvTextArea from 'shared/components/inputs/nv-text-area';
import ClickableContainer from 'components/clickable-container';
import NvIcon from 'shared/components/nv-icon';
import { primary } from 'styles/global_defaults/colors';
import AiConversationContext from './context';
import useAiRolePlayHelper from '../hooks/use-ai-role-play-helper';

const ChatBar = () => {
  const { getResponsivePadding } = useAiRolePlayHelper();

  const styles = css`
    padding-left: ${getResponsivePadding()}px;
    padding-right: ${getResponsivePadding()}px;
    :focus-within {
      .chat-box {
        border-color: ${primary} !important;
        .send-button {
          color: ${primary} !important;
        }
      }
    }
    .send-message-textarea {
      width: 90%;
      textarea {
        border: none;
        background-color: transparent;
      }
    }
    .send-button {
      width: 10%;
    }
`;
  const { aiRolePlayId } = useContext(AiConversationContext) || {};
  const aiRolePlay = useSelector((state) => getAiRolePlay(state, aiRolePlayId));

  return (
    <div css={styles} className='w-100 align-items-center mt-auto py-4'>
      <div className='d-flex border-bottom pb-4 bg-white chat-box'>
        <NvTextArea
          className='send-message-textarea'
          placeholder={t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.CONVERSATION_MODAL.SEND_MESSAGE_PLACEHOLDER()}
        />
        <ClickableContainer
          className='send-button text-gray-4'
          aria-label={t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.CONVERSATION_MODAL.SEND_MESSAGE()}
        >
          <NvIcon
            icon='admin-image-right'
            size='small'
            className='d-flex align-items-center mr-4 ml-auto'
          />
        </ClickableContainer>
      </div>
    </div>
  );
};

export default ChatBar;
